import PropTypes from 'prop-types';
import React from 'react';

const Switch = ({ selected, label, onChange, description, switchPosition, disabled }) => {
  const descriptionIdRef = React.useRef(
    'switch-desc-' + Math.random().toString(36).slice(2, 9)
  );
  const descriptionId = description ? descriptionIdRef.current : undefined;

  function handleChange(e) {
    onChange(e, e.target.checked);
  }

  return (
    <label className="switch">
      <input
        className="switch__input"
        type="checkbox"
        role="switch"
        checked={selected}
        disabled={disabled}
        onChange={handleChange}
        aria-describedby={descriptionId}
      />
      {switchPosition === 'left' && <span className="switch__track" />}
      {(label || description) && (
        <div className="switch__texts">
          {label && (
            <span title={label} className="switch__label">
              {label}
            </span>
          )}
          {description && (
            <span id={descriptionId} title={description} className="switch__description">
              {description}
            </span>
          )}
        </div>
      )}
      {switchPosition === 'right' && <span className="switch__track" />}
    </label>
  );
};

Switch.propTypes = {
  selected: PropTypes.bool,
  onChange: PropTypes.func,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  switchPosition: PropTypes.oneOf(['left', 'right']),
  label: PropTypes.string,
};

Switch.defaultProps = {
  selected: false,
  disabled: false,
  onChange: function () {},
  switchPosition: 'left',
};

export default Switch;
